import { render, staticRenderFns } from "./listComp.vue?vue&type=template&id=1db82ccc&scoped=true"
import script from "./listComp.vue?vue&type=script&lang=js"
export * from "./listComp.vue?vue&type=script&lang=js"
import style0 from "./listComp.vue?vue&type=style&index=0&id=1db82ccc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1db82ccc",
  null
  
)

export default component.exports